import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const salesRevenueWidget: DashboardWidgetConfiguration = {
  widgetId: "sales.revenue",
  name: "Sales revenue",
  description: "Revenue total for the selected period.",
  apps: [
    "appointments",
    "asset",
    "attendance",
    "configuration",
    "contracts",
    "crm",
    "document",
    "expenses",
    "field-service",
    "finance",
    "help-desk",
    "home",
    "hr",
    "integrations",
    "inventory",
    "invoicing",
    "maintanance",
    "manufacturing",
    "payroll",
    "point-of-sale",
    "procurement",
    "project",
    "recruitment",
    "rental",
    "sales",
    "schedule-planning",
    "subscriptions",
    "time-off",
    "timesheets",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "sales.analysis",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "revenue",
          as: "revenue",
        },
      ],
    },
  },
  inputs: {
    label: "Revenue",
    subtext: "Last 30 days",
    valueFormat: "currency",
    icon: "trend",
    color: "success",
  },
  dummyData: {
    value: "$84,250",
    subtext: "30-day revenue",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 3,
    defaultHeight: 1,
  },
};
